import type { Novidade } from './tipos';

/** Fase 2 (W36): os filtros que faltavam nas listas, comparados com o sistema antigo. */
export const novidadeFiltros: Novidade = {
  id: '2026-10-05-filtros',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'contas',
  permissao: 'contas.ver',
  textos: {
    pt: {
      titulo: 'Mais filtros nas listas do Financeiro e de Compras',
      resumo: 'A receber, A pagar, Movimentações e Compras ganharam os filtros do sistema antigo, à vista na tela e guardados no link e na visão salva.',
      passos: [
        'Em A receber e A pagar, escolha o período por vencimento ou competência, a categoria, o centro de custo e uma faixa de valor. Escolha também um ou mais clientes ou fornecedores: cada um vira uma etiqueta com o botão de tirar.',
        'Em Movimentações, filtre pela origem (lançados no Financeiro, baixas de títulos ou outros módulos) e pelo período de caixa ou de competência. Em Compras, pelo tipo (produto ou serviço), pelo fornecedor e pela competência.',
        'No Plano de contas, a busca acha a categoria pelo código ou pelo nome e mostra o caminho até ela.',
      ],
    },
    en: {
      titulo: 'More filters in the Finance and Purchasing lists',
      resumo: "Receivable, Payable, Transactions and Purchases got the old system's filters, on screen and kept in the link and in saved views.",
      passos: [
        'In Receivable and Payable, choose the period by due date or accrual date, the category, the cost center and an amount range. You can also pick one or more customers or suppliers: each one becomes a tag with a remove button.',
        'In Transactions, filter by source (entered in Finance, bill payments or other modules) and by cash or accrual period. In Purchases, by type (product or service), supplier and accrual date.',
        'In the Chart of accounts, the search finds a category by code or name and shows the path to it.',
      ],
    },
    es: {
      titulo: 'Más filtros en las listas de Finanzas y Compras',
      resumo: 'Por cobrar, Por pagar, Movimientos y Compras ganaron los filtros del sistema anterior, en pantalla y guardados en el enlace y la vista.',
      passos: [
        'En Por cobrar y Por pagar, elige el período por vencimiento o competencia, la categoría, el centro de costo y un rango de valor. También puedes elegir uno o más clientes o proveedores: cada uno se vuelve una etiqueta con el botón para quitarlo.',
        'En Movimientos, filtra por origen (registrados en Finanzas, pagos de títulos u otros módulos) y por el período de caja o de competencia. En Compras, por tipo (producto o servicio), proveedor y competencia.',
        'En el Plan de cuentas, la búsqueda encuentra la categoría por código o nombre y muestra el camino hasta ella.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-filtros/filtros.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/financeiro/contas/a-receber',
};
